import { MAP_TOOLS } from '@/components/mapControls/mapToolsCatalog.js'

export const restMap = {
    data() {
        return {
          map: {
            name: '',
            desc: '',
            imgurl: '',
            // Herramientas del visor habilitadas (QA-11). El formulario parte
            // con todas; los mapas guardados antes de QA-11 llegan sin el campo
            // y getMap los normaliza también a todas.
            tools: MAP_TOOLS.map(tool => tool.id)
          },
          maps: []
        }
    },
    methods: {
      getMap: function(){
        var that = this;
        this.$http.get(this.$store.getters.backendurl + 'api/v1/maps/' + this.$route.params.idMap)
        .then(function (response) {
            that.map = response.data;
            // null/ausente = todas las herramientas (mapas previos a QA-11)
            if (!that.map.tools) {
                that.map.tools = MAP_TOOLS.map(tool => tool.id)
            }
        })
        .catch(function (error) {
            console.log(error)
            that.message = error.response.data.message;
        });
      },
      getMapsPages: function(page){
        var that = this;
        this.$http.get(this.$store.getters.backendurl + 'api/v1/maps?page=' + page)
        .then(function (response) {
            that.maps = response.data;
            response.headers.totalpages == undefined ? that.totalPages = 0 : that.totalPages = parseInt(response.headers.totalpages, 10);
        })
        .catch(function (error) {
            console.log(error)
            that.message = error.response.data.message;
        });
      },
      getMapsNoPages: function(){
        var that = this;
        this.$http.get(this.$store.getters.backendurl + 'api/v1/maps/')
        .then(function (response) {
            that.maps = response.data;
        })
        .catch(function (error) {
            console.log(error)
            that.message = error.response.data.message;
        });
      },
      postMap: function(){
        var that = this;
        this.$http.post(this.$store.getters.backendurl + 'api/v1/maps', 
        this.map
        )
        .then(function (response) {
          let idMap= response.data.id
          that.$router.push('/mapas/'+ idMap)
        })
        .catch(function (error) {
            console.log(error);
        });
      },
      putMap: function(){
        var that = this;
        this.$http.put(this.$store.getters.backendurl + 'api/v1/maps/' + this.$route.params.idMap,
        this.map
        )
        .then(function (response) {
          that.$router.push('/mapas/'+ that.$route.params.idMap)
        })
        .catch(function (error) {
            console.log(error)
            that.message = error.response.data.message;
        });
      },
      deleteMap: function(){
        var that = this;
        this.$http.delete(this.$store.getters.backendurl + 'api/v1/maps/' + this.$route.params.idMap)
        .then(function (response) {
            that.$router.push('/mapas')
        })
        .catch(function (error) {
            console.log(error)
            that.message = error.response.data.message;
        });
      },
      getLayersByMap: function(){
        var that = this;
        return this.$http.get(this.$store.getters.backendurl + 'api/v1/maps/' + this.$route.params.idMap + '/layers/categories')
        .then(function (response) {
            console.log("HOLAAAAAAAA",response)
            that.$store.dispatch('setLayers', response.data)
        })
        .catch(function (error) {
            console.log(error)
            that.message = error.response.data.message;
        });
      },
      getGeoprocessingsByMap: function(){
        var that = this;
        this.$http.get(this.$store.getters.backendurl + 'api/v1/maps/' + this.$route.params.idMap + '/geoprocessings')
        .then(function (response) {
            that.$store.dispatch('setGeoprocessings', response.data)
        })
        .catch(function (error) {
            console.log(error)
            that.message = error.response.data.message;
        });
      },
    }
  }